import { ReactNode } from 'react';
import { cn } from '@v2/shared/lib/utils';

type Props = {
  type?: 'dashed' | 'solid';
  padding?: 'none' | 'snug' | 'loose';
  className?: string;
  children: ReactNode;
};

/**
 * The bordered card every section of this page sits in. Off headless_jshop, and only
 * used here — the storefront pages have their own idea of a panel.
 *
 * Dashed reads as "for information", solid as "there is something to do here"; the
 * recipient's address is the one dashed box on the page.
 */
export default function Box({ type = 'solid', padding = 'loose', className, children }: Props) {
  const paddingClasses = {
    none: 'p-0',
    snug: 'p-2',
    loose: 'p-3',
  };

  return (
    <div
      className={cn(
        'rounded-md border-[1.5px] border-slate-200 mb-8',
        type === 'dashed' ? 'border-dashed bg-slate-50' : 'border-solid bg-white',
        paddingClasses[padding],
        className
      )}
    >
      {children}
    </div>
  );
}

/** The line above a Box, naming what is in it. */
export function BoxLabel({ children }: { children: ReactNode }) {
  return <div className="font-medium text-slate-600 text-sm mb-1">{children}</div>;
}
